export class lqdScheduleTableHandler extends elementorModules.frontend.handlers.Base {

    onInit(...args) {

        super.onInit(...args);

        this.handleDestroy();

        this.initScheduleTable();
        this.initFilterableTable();
        this.initRadialReaction();

    }

    getDefaultSettings() {
        return {
            selectors: {
                scheduleTableElement: '[data-liquid-schedule-table]',
                filterableTableElement: '[data-filterable-table]',
                radialReactionElement: '[data-radial-reaction]',
            }
        }
    }

    getDefaultElements() {
        const selectors = this.getSettings('selectors');

        return {
            $scheduleTableElement: this.$element.find(selectors.scheduleTableElement),
            $filterableTableElement: this.$element.find(selectors.filterableTableElement),
            $radialReactionElement: this.$element.find(selectors.radialReactionElement),
        }
    }

    initScheduleTable() {

        this.elements.$scheduleTableElement.liquidScheduleTable();

    }

    initFilterableTable() {

        this.elements.$filterableTableElement.liquidFilterableTable();

    }

    initRadialReaction() {

        this.elements.$radialReactionElement.liquidRadialReaction();

    }

    onDestroy() {

        this.handleDestroy();

        super.onDestroy();

    }

    handleDestroy() {

        this.handleScheduleTableDestroy();
        this.handleFilterableTableDestroy();
        this.handleRadialReactionDestroy();

    }

    handleScheduleTableDestroy() {

        if (!this.elements.$scheduleTableElement.length) return;

        const scheduleTableData = this.elements.$scheduleTableElement.data('plugin_liquidScheduleTable');

        if (scheduleTableData && scheduleTableData.destroy) {
            scheduleTableData.destroy();
        }

    }

    handleFilterableTableDestroy() {

        if (!this.elements.$filterableTableElement.length) return;

        const filterableTableData = this.elements.$filterableTableElement.data('plugin_liquidFilterableTable');

        if (filterableTableData && filterableTableData.destroy) {
            filterableTableData.destroy();
        }

    }

    handleRadialReactionDestroy() {

        if (!this.elements.$radialReactionElement.length) return;

        const radialReactionData = this.elements.$radialReactionElement.data('plugin_liquidRadialReaction');

        if (radialReactionData && radialReactionData.destroy) {
            radialReactionData.destroy();
        }

    }

}

export default ($element) => {
    elementorFrontend.elementsHandler.addHandler(lqdScheduleTableHandler, { $element });
};